import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ENTITLEMENT_KEYS} from '@packages/systems/billing/common';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

export const canAccessAnalyticsPanel = defineAbilityConfig([
  {
    entitlements: [ENTITLEMENT_KEYS.ALLOW_ANALYZE_CORE],
  },
] as const);

export const canAccessAnalyzeVisualView = defineAbilityConfig([
  {
    entitlements: [ENTITLEMENT_KEYS.ALLOW_ANALYZE_CORE],
    pageTypes: {
      componentCanvas: false,
    },
  },
] as const);

export const canViewAnalyzeRightSidebar = defineAbilityConfig({
  workflows: {
    analyzeVisualView: true,
  },
} as const);

/**
 * Grants access to view data exports in Analyze.
 * Requires: Analyze core access, the data-exports entitlement (workspace has one of
 * workspaceEnterpriseAnalyze10m, workspaceEnterpriseAnalyze25m, or workspaceEnterpriseAnalyze50m),
 * and the Data Exports feature flag.
 */
export const canViewDataExportsForAnalyze = defineAbilityConfig({
  entitlements: [
    ENTITLEMENT_KEYS.ALLOW_ANALYZE_CORE,
    ENTITLEMENT_KEYS.ALLOW_ANALYZE_DATA_EXPORTS,
  ],
  featureFlags: {
    [FEATURE_FLAGS.DATA_OUT]: true,
  },
} as const);
